import { createContext } from '@lit/context'
import { NodeData } from './contextual-one-ux-tree/types'

export interface ITreeContext {
  tree: NodeData[]
  activeNode: NodeData | null
  multiple: boolean
  value: string[]

  setValue(node: NodeData): void
  setActiveNode(node: NodeData): void
}

export const treeContext = createContext<ITreeContext>('treeContext')
